import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-convocation-popup',
  templateUrl: './convocation-popup.component.html',
  styleUrls: ['./convocation-popup.component.less',  '../../shared/common.less']
})
export class ConvocationPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() isResend = true;
  @Input() isAssessors = false;

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }
}
